import React from 'react';
import './About.css';

function About() {
  return (
    <section id="about" className="about">
      <div className="container">
        <h2 className="fade-in">About TKS Courier & Cargo</h2>
        <div className="about-content">
          <div className="about-text fade-in fade-in-delay-1">
            <div className="animated-person">
              <div className="person-emoji">👨‍💼</div>
            </div>
            <p>
              TKS Courier & Cargo International Service is a leading provider of comprehensive
              logistics and courier services in Singapore. With years of experience in the industry,
              we have built a reputation for reliability, efficiency, and exceptional customer service.
            </p>
            <p>
              Our commitment to excellence drives us to deliver innovative solutions that meet
              the evolving needs of our clients. Whether you need same-day delivery, international
              shipping, or specialized cargo handling, our expert team ensures your shipments
              arrive safely and on time.
            </p>
            <p>
              We pride ourselves on our extensive network, advanced tracking systems, and
              dedication to maintaining the highest standards of service quality. Trust TKS
              Courier & Cargo for all your shipping and logistics requirements.
            </p>
          </div>
          <div className="about-features fade-in fade-in-delay-2">
            <div className="feature">
              <h4>✓ Reliable Service</h4>
              <p>Consistent and dependable delivery solutions</p>
            </div>
            <div className="feature">
              <h4>✓ Global Network</h4>
              <p>Extensive international shipping capabilities</p>
            </div>
            <div className="feature">
              <h4>✓ Real-time Tracking</h4>
              <p>Advanced tracking systems for complete visibility</p>
            </div>
            <div className="feature">
              <h4>✓ Expert Team</h4>
              <p>Professional staff with industry expertise</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;